<template lang="html">
  <div class="container">
    <div class="form-container">
      <form @submit.prevent="reset">
        <div class="fields">
          <input v-model="password" type="password" name="password" placeholder="New password" required autofocus />
          <input v-model="password_confirmation" type="password" name="password_confirmation" placeholder="Confirm new password" required />
        </div>
        <input type="submit" class="button" name="submit" value="Update password" />
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Reset",
    data() {
      return {
        password: "",
        password_confirmation: "",
      };
    },
    methods: {
      reset() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .post("/reset", {
            password: this.password,
            password_confirmation: this.password_confirmation,
            reset_token: this.$route.params.token,
          })
          .then((response) => this.resetSuccess(response))
          .catch(() => this.resetFail());
      },

      resetSuccess(response) {
        this.$store.commit("setLoadingStatus", false);

        if (!response.data.token) {
          this.resetFail();
          return;
        }
        this.$store.commit("dismissError");
        localStorage.token = response.data.token;
        localStorage.role = response.data.role;
        this.$router.replace("/");
      },

      resetFail() {
        this.$store.commit("setLoadingStatus", false);

        this.$store.commit("setError", {
          message: "Failed to set new password, make sure the confirmation matches",
          type: "error",
        });
      },
    },
  };
</script>

<style scoped lang="css">
  .container {
    width: 100%;
    height: 100%;
    background-color: #b2773c;
    padding: 20px;
  }

  .form-container {
    max-width: 500px;
    margin: 0 auto;
    background-color: #fff;
    padding: 10px 20px;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: 10px 10px 10px #8c5925;
  }

  .fields {
    margin-bottom: 50px;
  }

  @media screen and (max-height: 600px) {
    .container {
      height: auto;
    }

    .form-container {
      top: auto;
      transform: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Password/Reset.vue